import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { IMultiSelectSettings } from '../multi-select/models/multi-select-settings.interface';
import { IOption } from '../multi-select/models/option.interface';
import { CustomControlValueAccessor } from '../../utils/custom-control-value-accessor/custom-control-value-accessor';
import { OperacaoContaOrdem } from '../../../../home/pedido/domain';

@Component({
  selector: 'sgt-novo-operacao-conta-ordem-multiselect',
  templateUrl: './novo-operacao-conta-ordem-multiselect.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NovoOperacaoContaOrdemMultiselectComponent),
      multi: true
    }
  ]
})
export class NovoOperacaoContaOrdemMultiselectComponent
  extends CustomControlValueAccessor<number[]>
  implements OnInit {
  @Input() idsOperacoesContaOrdem: number[];
  @Output() idsOperacoesContaOrdemChange = new EventEmitter<number[]>();

  settings: IMultiSelectSettings = {
    placeholder: 'Selecione as operações de conta e ordem',
    plural: 'Operações de Conta e Ordem',
    singular: 'Operação de Conta e Ordem',
    searchEmptyResultMessage: 'Nenhuma operação de conta e ordem encontrada',
    showFooter: false
  };

  options: IOption[] = [];

  constructor() {
    super();
  }

  ngOnInit() {
    this.create();
  }

  private create() {
    this.options = OperacaoContaOrdem.getAll().map((operacaoContaOrdem) => ({
      id: operacaoContaOrdem.id,
      label: operacaoContaOrdem.nome
    }));
  }

  protected updateValue(newValue: number[] | null): void {
    this.idsOperacoesContaOrdem = newValue;
  }

  onSearch() {
    this.idsOperacoesContaOrdemChange.emit(this.idsOperacoesContaOrdem);
  }

  onSelectionChange() {
    this.emitChange(this.idsOperacoesContaOrdem);
    this.markAsTouched();
  }
}
